module.exports = __webpack_public_path__ + "static/media/orcamentoIcon.4da514f6.svg";